import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, CircularProgress, Paper, Typography } from "@mui/material";
import Header from "../components/header";
import Footer from "../components/footer";
import getApiBase from "../components/getApiBase";

const ConfirmVoiceBooking = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(
          `${getApiBase()}/api/ezvoice/booking-confirm/${token}`,
        );
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error || "This link is invalid or expired.");
        }
        if (!cancelled) setDetails(data);
      } catch (err) {
        if (!cancelled) setError(err.message || "This link is invalid or expired.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <>
      <Header />
      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f7f9fc",
          px: 2,
          py: 6,
        }}
      >
        <Paper elevation={3} sx={{ maxWidth: 500, width: "100%", p: 4, textAlign: "center", borderRadius: 3 }}>
          {loading ? (
            <>
              <CircularProgress size={60} sx={{ color: "#e63926", mb: 3 }} />
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Opening your appointment link...
              </Typography>
            </>
          ) : error ? (
            <>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                Link not valid
              </Typography>
              <Typography variant="body1">{error}</Typography>
            </>
          ) : (
            <>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                Confirm your appointment
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {details.acceptedSlot}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {details.mode === "create"
                  ? "Create your account to confirm this time."
                  : "Log in to confirm this time on your account."}
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate(details.nextPath)}
                sx={{ backgroundColor: "#e63926", "&:hover": { backgroundColor: "#c62f1e" } }}
              >
                {details.mode === "create" ? "Create account" : "Log in"}
              </Button>
            </>
          )}
        </Paper>
      </Box>
      <Footer />
    </>
  );
};

export default ConfirmVoiceBooking;
